import { Rule } from '@webkit/validation/value';

export const integer = (error?: string) =>
    ({
        id: 'integer',
        validator: value =>
            value === '' || value === undefined || value === null || /^-?\d+$/.test(value.toString().replace(/,/g, '')),
        error: () => error || 'Enter a whole number',
    } as Rule<string | number>);
